<div class="ba-form-group ba-layout-tile" [attr.aria-labelledby]="id">
    <div class="ba-form-group-info ba-copytext">
        <h2 class="ba-heading" [id]="id">
            <span class="visually-hidden">{{ title }}</span>
            <span aria-hidden="true" [innerHTML]="sanitizedTitle"></span>
        </h2>

        @if (subtitle) {
            <p [id]="'sec-sub-' + name">{{ subtitle }}</p>
        }
    </div>

    <div class="ba-form-group-fields">
        <ng-content></ng-content>
    </div>
</div>